import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle, Input, Button } from "../../shared/components";
import { useAppSelector, useAppDispatch } from "../../shared/hooks";
import { validateAccessCode, clearError } from "../../store/slices/authSlice";

const LoginScreen = () => {
  const [code, setCode] = useState("");
  const dispatch = useAppDispatch();
  
  const { loading, error } = useAppSelector(state => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;

    dispatch(validateAccessCode(code.trim()));
  };

  const handleCodeChange = (e) => {
    setCode(e.target.value);
    if (error) {
      dispatch(clearError());
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <Card className="w-full max-w-md">
        
        <CardHeader className="text-center">
          <img 
            src="/logoblanco-y-negro.png"
            alt="Logo"
            className="mx-auto mb-4 h-16"
          />
          <CardTitle className="text-2xl font-bold text-gray-900">
            Reservar Entradas
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Input
                id="code"
                type="text"
                value={code}
                onChange={handleCodeChange}
                placeholder="Ingresa tu código"
                className="mt-1 h-12 text-base"
                disabled={loading}
                autoFocus
              />
            </div>
            
            {error && (
              <div className="text-red-600 text-sm bg-red-50 p-3 rounded-md">
                {error}
              </div>
            )}
            
            <Button
              type="submit"
              className="w-full h-12 text-base font-semibold"
              disabled={loading || !code.trim()}
            >
              {loading ? "Validando..." : "Acceder"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginScreen; 